import React from 'react'

import { makeStyles, useTheme } from '@material-ui/core'
import { styles } from './helpContent.styles'

import Fade from '@material-ui/core/Fade'
import { DataTableSkeleton } from '@globaleris/ui.library'
import { fetchHelpContent } from './helpPanel.service'

import ReactMarkdown from 'react-markdown'
import gfm from 'remark-gfm'
import toc from 'remark-toc'
import { Prism as SyntaxHighlighter } from 'react-syntax-highlighter'

interface HelpContentProps {
  contentPath: string
}

export const HelpContent: React.FC<HelpContentProps> = ({ contentPath }) => {
  const currentTheme = useTheme()
  const useStyles = makeStyles(styles(currentTheme))
  const classes = useStyles()

  const [wikiContent, setWikiContent] = React.useState<string>()

  React.useEffect(() => {
    const getContentForPath = async (path: string) => {
      const response = await fetchHelpContent(path)
      setWikiContent(response)
    }
    getContentForPath(contentPath)
  }, [contentPath])

  const customRenderers = {
    code: ({ language, value }) => {
      return <SyntaxHighlighter language={language} children={value} wrapLongLines />
    },
    table: ({ ...props }) => {
      return <table className={classes.tableRoot}>{props.children}</table>
    },
    image: ({ ...props }) => {
      return <img className={classes.imageRoot} src={props.src} alt={props.alt} />
    },
    link: ({ ...props }) => {
      if (props.href.includes('https://www.youtube.com')) {
        return (
          <iframe
            className={classes.embededVideoRoot}
            src={props.href}
            title={props.href}
            allowFullScreen
            frameBorder={0}
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          ></iframe>
        )
      }
      if (props.href.startsWith('#')) {
        // avoid anchor links generated for the table of contents.
        return <h4>{props.children}</h4>
      }
      return (
        <a href={props.href} target="_blank" rel="noreferrer">
          {props.children}
        </a>
      )
    }
  }

  return (
    <Fade in>
      {wikiContent ? (
        <ReactMarkdown
          className={classes.wikiContentRoot}
          renderers={customRenderers}
          plugins={[
            gfm,
            [
              toc,
              {
                heading:
                  'Table of Contents|Tabla de Contenidos|Contenido|Índice|Indice|Index|.*TOC.*',
                tight: true
              }
            ]
          ]}
          source={wikiContent}
        ></ReactMarkdown>
      ) : (
        <DataTableSkeleton />
      )}
    </Fade>
  )
}
